module.exports = __webpack_public_path__ + "resources/img/logo_TCC.d97ea30d9879d54f324da7d618a5b60b.svg";